import axios from 'axios';

const PSCGApi = {
  async get(endpoint) {
    var responseData;
    await axios({
      method: 'get',
      url: 'https://psgc.gitlab.io/api' + endpoint
    }).then(response => {
      responseData = response.data;
    });

    return responseData;
  }
};

export default PSCGApi;
